export const getAuthorizationToken = () => localStorage.getItem('authorization_token');
export const setAuthorizationToken = token => localStorage.setItem('authorization_token', token);
export const removeAuthorizationToken = () => localStorage.removeItem('authorization_token');
export const checkAuthorizationToken = () => {
    try {
        const { exp } = JSON.parse(atob(getAuthorizationToken().split('.')[1]));
        const isExp = exp <= Math.floor(Date.now() / 1000);

        if (isExp) {
            removeAuthorizationToken();
        }

        return !isExp;
    } catch {
        return false;
    }
};
